/**
 * Landing Page
 * Main navigation page for the tea ceremony historical explorer
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Network, Database, ArrowRight, Sparkles } from 'lucide-react';

const LandingPage = () => {
  return (
    <div className="min-h-screen" style={{ background: '#fafafa' }}>
      <div className="container mx-auto px-6 py-12">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{
            color: '#000',
            fontFamily: 'Avenir, Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif'
          }}>
            好日会席 Visualizer
          </h1>
          <p className="text-xl max-w-2xl mx-auto leading-relaxed" style={{ color: '#000' }}>
            Visualizer for items and people involved in Joi's 好日会席
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Timeline View */}
          <Link to="/timeline" className="group">
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-gray-200 hover:border-gray-300 transform hover:-translate-y-1" style={{ background: '#F5F5F5' }}>
              <div className="flex items-center justify-center w-16 h-16 rounded-xl mb-6 group-hover:opacity-80 transition-colors" style={{ backgroundColor: '#1A80B4' }}>
                <Calendar className="text-white" size={32} />
              </div>

              <h3 className="text-2xl font-bold mb-4" style={{
                color: '#000',
                fontFamily: 'Avenir, Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif'
              }}>Timeline View</h3>
              <p className="mb-6 leading-relaxed" style={{ color: '#000' }}>
                Chronological visualization of people and events
              </p>

              <div className="flex items-center font-medium" style={{ color: '#1A80B4' }}>
                View Timeline
                <ArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" size={16} />
              </div>
            </div>
          </Link>

          {/* Network View */}
          <Link to="/network" className="group">
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-gray-200 hover:border-gray-300 transform hover:-translate-y-1" style={{ background: '#F5F5F5' }}>
              <div className="flex items-center justify-center w-16 h-16 rounded-xl mb-6 group-hover:opacity-80 transition-colors" style={{ backgroundColor: '#0299ce' }}>
                <Network className="text-white" size={32} />
              </div>

              <h3 className="text-2xl font-bold mb-4" style={{
                color: '#000',
                fontFamily: 'Avenir, Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif'
              }}>Network View</h3>
              <p className="mb-6 leading-relaxed" style={{ color: '#000' }}>
                Interactive network of relationships and connections
              </p>

              <div className="flex items-center font-medium" style={{ color: '#0299ce' }}>
                View Network
                <ArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" size={16} />
              </div>
            </div>
          </Link>

          {/* Data Editor */}
          <Link to="/editor" className="group">
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-gray-200 hover:border-gray-300 transform hover:-translate-y-1" style={{ background: '#F5F5F5' }}>
              <div className="flex items-center justify-center w-16 h-16 rounded-xl mb-6 group-hover:opacity-80 transition-colors" style={{ backgroundColor: '#146087' }}>
                <Database className="text-white" size={32} />
              </div>

              <h3 className="text-2xl font-bold mb-4" style={{
                color: '#000',
                fontFamily: 'Avenir, Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif'
              }}>Data Editor</h3>
              <p className="mb-6 leading-relaxed" style={{ color: '#000' }}>
                View and edit the underlying data
              </p>

              <div className="flex items-center font-medium" style={{ color: '#146087' }}>
                Open Editor
                <ArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform" size={16} />
              </div>
            </div>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default LandingPage;